import React, { useEffect, useState } from "react";
import { API_URL } from "../../../config";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../common/Pagination";
import {
  Badge,
  Row,
  Col,
  Dropdown,
  Button,
  Form,
  InputGroup,
} from "react-bootstrap";
import { setCourses } from "../../../store/actions/CourseAction";
import moment from "moment";

const passoutYears = [
  "Till Now",
  moment().year() - 2,
  moment().year() - 1,
  moment().year(),
  moment().year() + 1,
  moment().year() + 2,
];
const PlacementActivites = () => {
  const [placementActivities, setPlacementActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const collegeId = useSelector((state) => state.college_id.college_id);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecord, setTotalRecord] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [course, setCourse] = useState(null);
  const [passoutYear, setPassoutYear] = useState(null);
  const courses = useSelector((state) => state.courses.courses);
  const dispatch = useDispatch();
  useEffect(() => {
    const storedCourses = localStorage.getItem("courses");
    if (storedCourses) {
      dispatch(setCourses(JSON.parse(storedCourses)));
    }
  }, [dispatch]);

  const itemsPerPage = 10;

  const fetchPlacementActivities = async () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const authToken = userDetails?.data?.auth_token;
    const formData = new FormData();
    formData.append("college_id", collegeId);
    formData.append("offset", currentPage * itemsPerPage);
    formData.append("limit", itemsPerPage);
    if (course && course?.filter_id) {
      formData.append("filter_by_course", course.filter_id);
    }
    if (passoutYear && passoutYear !== "Till Now") {
      formData.append("passout_year", passoutYear);
    }
    if (searchTerm) {
      formData.append("search", searchTerm);
    }
    setLoading(true);
    try {
      const response = await axios.post(
        `${API_URL}/api/freshment_portal_apis/Jobs/get_job_application_tracking_by_college`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      setPlacementActivities(response.data?.data || []);
      setTotalRecord(response.data?.totalRecords || 0);
      setTotalPages(Math.ceil(response.data?.totalRecords / itemsPerPage));
    } catch (error) {
      console.error("Error fetching placement activities:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPlacementActivities();
  }, [currentPage, course, passoutYear]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = () => {
    fetchPlacementActivities();
  };

  const resetFilters = () => {
    setSearchTerm("");
    setCourse(null);
    setPassoutYear(null);
    setCurrentPage(0);
    fetchPlacementActivities();
  };

  // Helper function to determine activity type based on stage
  const getActivityType = (stage) => {
    if (!stage) return "";
    return stage.charAt(0).toUpperCase() + stage.slice(1);
  };

  return (
    <>
      {/* Title Section */}
      {/* <div className="mb-4">
        <h3 className="m-0 font-weight-bold">Placement Activities</h3>
      </div> */}

      <div className="d-flex align-items-center flex-wrap search-job bg-white px-0 mb-4">
        <div className="col-xl-2 col-xxl-2 col-lg-4 col-sm-4 col-12 search-dropdown d-flex align-items-center">
          <Dropdown className="form-control border-0 style-1 h-auto">
            <Dropdown.Toggle
              as="div"
              className="fs-16 font-w500 text-primary justify-content-between d-flex align-items-center i-false"
            >
              {course?.name ?? "Select Course"}
              <i className="fas fa-angle-down text-primary scale5 ms-3"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu dropdown-menu-end mt-1">
              <Dropdown.Item
                className="text-primary"
                onClick={() => {
                  setCourse(null);
                }}
              >
                All
              </Dropdown.Item>
              {courses &&
                courses?.length > 0 &&
                courses?.map((course, index) => (
                  <Dropdown.Item
                    key={index}
                    className="text-primary"
                    onClick={() => {
                      setCourse(course);
                    }}
                  >
                    {course.name}
                  </Dropdown.Item>
                ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-xl-2 col-xxl-2 col-lg-4 col-sm-4 col-12 search-dropdown d-flex align-items-center">
          <Dropdown className="form-control border-0 style-1 h-auto">
            <Dropdown.Toggle
              as="div"
              className="fs-16 font-w500 text-primary justify-content-between d-flex align-items-center i-false"
            >
              {passoutYear ?? "Select Passout Year"}
              <i className="fas fa-angle-down text-primary scale5 ms-3"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu dropdown-menu-end mt-1">
              {passoutYears.map((year, index) => (
                <Dropdown.Item
                  key={index}
                  className="text-primary"
                  onClick={() => {
                    setPassoutYear(year);
                  }}
                >
                  {year}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-xl-7 col-xxl-7 col-lg-12 col-12 d-md-flex job-title-search pe-0">
          <div className="input-group search-area">
            <input
              type="text"
              className="form-control h-auto"
              placeholder="Search User name/email..."
              onChange={(e) => setSearchTerm(e.target.value)}
              value={searchTerm}
            />
            <span className="input-group-text">
              <Button onClick={handleSearch} className="btn btn-primary btn-sm">
                Search <i className="flaticon-381-search-2 ms-1" style={{ fontSize: '14px', verticalAlign: 'middle' }}></i>
              </Button>
            </span>
          </div>
        </div>{" "}
        <div className="col-xl-1 col-xxl-1 col-lg-1 col-12 d-flex align-items-center justify-content-lg-end justify-content-center">
          <button onClick={resetFilters} className="btn btn-danger btn-sm">
            Reset
          </button>
        </div>
      </div>

      {/* Table Section */}
      <div className="bg-white rounded-lg shadow-sm">
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading activities...</p>
          </div>
        ) : placementActivities.length > 0 ? (
          <div
            className="table-responsive dataTables_wrapper"
            id="application-data"
          >
            <table className="table display mb-4 dataTablesCard job-table table-responsive-xl card-table dataTable no-footer">
              <thead>
                <tr role="row">
                  <th className="sorting_asc" style={{ width: "10%" }}>
                    Stage
                  </th>
                  <th className="sorting_asc" style={{ width: "20%" }}>
                    Name
                  </th>
                  <th className="sorting_asc" style={{ width: "30%" }}>
                    Title
                  </th>
                  <th className="sorting_asc" style={{ width: "40%" }}>
                    Remarks
                  </th>
                </tr>
              </thead>
              <tbody>
                {placementActivities?.map((placementActivity, index) => (
                  <tr role="row" key={index} className="odd">
                    {" "}
                    <td>{getActivityType(placementActivity.stage)}</td>
                    <td>{placementActivity.user_name}</td>
                    <td>{placementActivity.job_title}</td>
                    <td>{placementActivity.remark}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center py-5">
            <div className="mb-3">
              <i className="fas fa-file-alt fa-3x text-muted"></i>
            </div>
            <h5>No placement activities found</h5>
            <p className="text-muted">
              No placement activities have been recorded yet.
            </p>
          </div>
        )}
      </div>
      {totalPages > 1 && (
        <div className="p-3 border-top">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalRecord={totalRecord}
            handlePageChange={handlePageChange}
            itemsPerPage={itemsPerPage}
          />
        </div>
      )}
    </>
  );
};

export default PlacementActivites;
